import {
  parse,
} from '../common/utils/querystring';

const query = parse(window.location.search);

const isDebug = process.env.NODE_ENV !== 'production' || !!query.debug;

export default isDebug;
